<template>
  <div>
    <editor
      api-key="0du12wancmdh8u2beh8jknd708tymkahaz0qe73g9xlv2v1r"
      :init="editConfig"
      v-model="content"
    ></editor>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
export default {
  name: "TinymceVueDemoAdv",
  data() {
    var useDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return {
      content: "",
      editConfig: {
        selector: "textarea#full-featured",
        plugins:
          "print preview powerpaste casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker imagetools textpattern noneditable help formatpainter permanentpen pageembed charmap tinycomments mentions quickbars linkchecker emoticons advtable",
        tinydrive_token_provider: "URL_TO_YOUR_TOKEN_PROVIDER",
        tinydrive_dropbox_app_key: "YOUR_DROPBOX_APP_KEY",
        tinydrive_google_drive_key: "YOUR_GOOGLE_DRIVE_KEY",
        tinydrive_google_drive_client_id: "YOUR_GOOGLE_DRIVE_CLIENT_ID",
        mobile: {
          plugins:
            "print preview powerpaste casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker textpattern noneditable help formatpainter pageembed charmap mentions quickbars linkchecker emoticons advtable",
        },
        menu: {
          tc: {
            title: "TinyComments",
            items: "addcomment showcomments deleteallconversations",
          },
        },
        menubar: "file edit view insert format tools table tc help",
        toolbar:
          "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment",
        autosave_ask_before_unload: true,
        autosave_interval: "30s",
        autosave_prefix: "{path}{query}-{id}-",
        autosave_restore_when_empty: false,
        autosave_retention: "2m",
        image_advtab: true,
        link_list: [
          { title: "My page 1", value: "https://www.tiny.cloud" },
          { title: "My page 2", value: "http://www.moxiecode.com" },
        ],
        image_list: [
          { title: "My page 1", value: "https://www.tiny.cloud" },
          { title: "My page 2", value: "http://www.moxiecode.com" },
        ],
        image_class_list: [
          { title: "None", value: "" },
          { title: "Some class", value: "class-name" },
        ],
        importcss_append: true,
        templates: [
          {
            title: "New Table",
            description: "creates a new table",
            content:
              '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
          },
          {
            title: "Starting my story",
            description: "A cure for writers block",
            content: "Once upon a time...",
          },
          {
            title: "New list with dates",
            description: "New List with dates",
            content:
              '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
          },
        ],
        template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
        template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
        height: 600,
        image_caption: true,
        quickbars_selection_toolbar:
          "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
        noneditable_noneditable_class: "mceNonEditable",
        toolbar_mode: "sliding",
        spellchecker_ignore_list: ["Ephox", "Moxiecode"],
        tinycomments_mode: "embedded",
        content_style: ".mymention{ color: gray; }",
        contextmenu: "link image imagetools table configurepermanentpen",
        a11y_advanced_options: true,
        skin: useDarkMode ? "oxide-dark" : "oxide",
        content_css: useDarkMode ? "dark" : "default",
        /*
  The following settings require more configuration than shown here.
  For information on configuring the mentions plugin, see:
  https://www.tiny.cloud/docs/plugins/premium/mentions/.
  */
        mentions_selector: ".mymention",
        mentions_fetch: mentions_fetch,
        mentions_menu_hover: mentions_menu_hover,
        mentions_menu_complete: mentions_menu_complete,
        mentions_select: mentions_select,
        mentions_item_type: "profile",
      },
    };
  },
  components: {
    editor: Editor,
  },
};
// 图片上传三个参数，图片数据，成功时的回调函数，失败时的回调函数
function tiny_image_upload_handler(blobInfo, success, failure, progress) {
  let formdata = new FormData();
  formdata.append("file", blobInfo.blob(), blobInfo.filename());
  // 上传图片接口，跟后端同事协调上传图片
  // http://hh.xxxx.cn/admin/upload为上传图片接口
  axios
    .post("http://hh.xxxx.cn/admin/upload", formdata)
    .then(function (res) {
      success(res.data.data.src);
      // success(json.location)
    })
    .catch((res) => {
      failure("error");
    });
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/MarkdownEditor/TinymceVueDemoAdv.vue